// apps/provider/src/services/api/scanSession.js
// Scan session management for QR-based document scanning
//
// Methods: createScanSession, getScanSession, completeScanSession, expireScanSession

/**
 * @returns {Object} Scan session domain methods (bound to `this` of the composed apiService)
 */
export function createScanSessionMethods() {
  return {
    /**
     * Create a new scan session for a patient.
     * Generates a short-lived token used in the mobile scan URL.
     *
     * Xano: POST /scan-session
     *
     * @param {string} patientId
     * @returns {Promise<{id: string, token: string, status: string, expires_at: number}>}
     */
    createScanSession(patientId) {
      return this.request('/scan-session', {
        method: 'POST',
        body: JSON.stringify({ patient_id: patientId }),
      });
    },

    /**
     * Get a scan session with its pages.
     * Used for polling on the desktop to see incoming scanned pages.
     *
     * Xano: GET /scan-session/{id}
     *
     * @param {string} sessionId
     * @returns {Promise<{id: string, token: string, status: string, expires_at: number, page_count: number, pages: Array<{id: number, page_number: number, file: object, file_size: number}>}>}
     */
    getScanSession(sessionId) {
      return this.request(`/scan-session/${sessionId}`, {
        method: 'GET',
      });
    },

    /**
     * Mark a scan session as completed.
     *
     * Xano: PATCH /scan-session/{id}
     *
     * @param {string} sessionId
     * @returns {Promise<object>}
     */
    completeScanSession(sessionId) {
      return this.request(`/scan-session/${sessionId}`, {
        method: 'PATCH',
        body: JSON.stringify({ status: 'completed' }),
      });
    },

    /**
     * Mark a scan session as expired (cancelled by user).
     *
     * Xano: PATCH /scan-session/{id}
     *
     * @param {string} sessionId
     * @returns {Promise<object>}
     */
    expireScanSession(sessionId) {
      return this.request(`/scan-session/${sessionId}`, {
        method: 'PATCH',
        body: JSON.stringify({ status: 'expired' }),
      });
    },
  };
}
